// extracted by mini-css-extract-plugin
export default {"input_field":"CreateWishlistModal_input_field__gSuZy","label_form":"CreateWishlistModal_label_form__5o9jW"};